import { BehaviorSubject } from 'rxjs';

export const selectedConversation$ = new BehaviorSubject<number | null>(null);

// for showing the Red dot on the Video Chat
export const isNewMessageReceivedSubject = new BehaviorSubject<boolean>(false);
